// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import HelpCircle from "@insite/mobius/Icons/HelpCircle";
import { userSetupSettingsStyles } from "@sc/Overrides/Widgets/UserSetup/UserSetupSettings";
import { css } from "styled-components";

userSetupSettingsStyles.roleSelectHelpIcon = {
    src: HelpCircle,
    size: 16,
    css: css`
        margin-left: 5px;
        margin-right: 5px;
        cursor: pointer;
        vertical-align: middle;
    `,
};
